import styled from 'styled-components';
import { rgba } from 'polished';
import { Div, Textfield } from 'components';

export const Wrapper = styled(Div)`
  display: flex;
  flex-direction: column;
  width: 800px;

  @media(max-width: 920px){
    padding: 24px 16px !important;
    width: 100%;
  }
  @media(min-width: 921px){
    width: 100%;
  }
`;

export const StyledTextField = styled(Textfield)`
  border: 1px solid ${({theme, isFocused}) => isFocused ? theme.colors.gray[theme.borders[0]] : 'white'};
  padding: 12px 0;
  @media(max-width: 920px){
    margin-top: 10px;
    border: none;
    border-radius: 4px;
    background-color: white;
    width: 100%;
  }
`;

export const SearchListWrapper = styled(Div)`
  display: flex;
  position: relative;
  flex-direction: column;
  z-index: 1;
  width: inherit;
`;

export const SearchList = styled.ul`
  /* display: ${props => props.isOpen ? 'flex' : 'none'}; */
  width: inherit;
  display: flex;
  position: absolute;
  flex-direction:column;
  list-style-type: none;
  border: 1px solid ${({theme}) => theme.colors.gray[theme.borders[0]]};
  border-top: none;
  padding-bottom: 16px;
  background-color: white;
  max-height: 500px;
  overflow: auto;
`;

export const ListItem = styled.li`
  text-decoration: none;
  background-color: white;
  display: flex;
  padding: 0 16px;
  padding-top: 16px;
  flex-direction: column;
  border-bottom: 1px solid ${rgba('#121212', 0.2)};
  cursor: pointer;

  &:hover{
    background-color: ${({theme}) => theme.colors[theme.background.quintenary.color][theme.background.quintenary.intensity]};
  }
`;

export const Toptext = styled.small`
  font-family: ${({theme}) => theme.fonts.primary};
  font-size: ${({theme}) => theme.fonts.size.md};
  color: ${({theme}) => rgba(theme.colors.gray[theme.text[0]], 0.8)};
  line-height: ${({theme}) => theme.fonts.lineHeight[1]};
  font-weight: ${({theme}) => theme.fonts.weight[0]};
`;

export const NameCnpjWrapper = styled(Div)`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 16px;

  @media(max-width: 920px){
    flex-direction: column;
  }
`;